import { z } from 'zod';

import { parseOrThrow } from '../../api';
import type { ScreenRules } from '../types';

const count = z.number().int().positive();

// The server does not serve a reason cap yet. Until it does, reasons are capped
// at the 500 characters the backend is being asked to enforce.
const DEFAULT_REASON_MAX_LENGTH = 500;

export const screenRulesSchema = z.object({
  codeLength: count,
  passwordMinLength: count,
  reasonMinLength: count,
  reasonMaxLength: count.default(DEFAULT_REASON_MAX_LENGTH),
});

export const parseScreenRules = (raw: unknown): ScreenRules => parseOrThrow(screenRulesSchema, raw, 'rules');
